export const productListShopifyCollectionBlock = `
_type == 'productListShopifyCollectionBlock' => {
  ...,
  "password": password[_key == $lang][0].value,
  "lock_message": lock_message[_key == $lang][0].value,
  "unlock_input_text": unlock_input_text[_key == $lang][0].value,
  "unlock_button_text": unlock_button_text[_key == $lang][0].value,
  "unlock_message": unlock_message[_key == $lang][0].value,
}
`
